var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg07(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_511_44500"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_511_44500)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 0,
    fill: "#FFFFFF",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48.000001999999995,40.871078C45.64333,43.165873,42.400282000000004,44.461377999999996,39.012374,44.461377999999996C32.1031189,44.461377999999996,26.5020623,39.18051,26.5020623,32.6662273C26.5020623,31.0615299,26.8493524,29.4737073,27.5226812,27.999924599542C25.2632746,30.2000117,24,33.1423669,24,36.204772C24,42.719056,29.6010566,47.999924,36.510310000000004,47.999924C41.506414,47.999924,46.023485,45.197283,48.000001999999995,40.871078Z",
    fillRule: "evenodd",
    fill: "#C00000",
    fillOpacity: 0.30000001192092896
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39,
    cy: 32,
    rx: 13,
    ry: 13,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#19191A",
    fill: "none",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,19.75L24,19.75L24,18.25L30,18.25L30,19.75Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40,45.75L22,45.75L22,44.25L40,44.25L40,45.75Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.25,21L23.25,17L24.75,17L24.75,21L23.25,21Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.25,47L21.25,43L22.75,43L22.75,47L21.25,47Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 16,
    width: 7,
    height: 6,
    rx: 1,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#19191A",
    fill: "none",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 42,
    width: 7,
    height: 6,
    rx: 1,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#19191A",
    fill: "none",
    strokeWidth: 1.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg07);
export default __webpack_public_path__ + "static/media/07.87512467ef037292834662f93055bc13.svg";
export { ForwardRef as ReactComponent };